import { gql } from '@apollo/client';

export const GET_AI_ANALYSIS_STEPS = gql`
  query RagAnalysisSchemaFindMany {
    ragAnalysisSchemaFindMany {
      embeddingText
      metadata {
        status
      }
      isFalsePositive
      urlTestId
      historicalAiAnalysis
      _id
      testExecutionId
    }
  }
`;
